export default "__VITE_ASSET__BXDNZZTc__"